import React from 'react';
import 'react-slideshow-image/dist/styles.css';
import '../../styles/gallery.css';
import GalleryTabbedView from '../../components/GalleryTabbedView';

export default function Gallery() {
    return (
        <div className='gallery'>
            <div className='gallery-container'>
                <GalleryTabbedView />
            </div>
        </div>
    );
}
